export const fetchData = () =>
	fetch('/api', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			query: `
				{
					vendorDetails: entries(section: "shop") {
						... on shop_Entry {
							id
							firstName
							opening
							closing
						}
					}
					sellerCheckins: entries(section: "checkin") {
						... on checkin_Entry {
							lat
							lng
							start
							end
							seller {
								id
								title
							}
						}
					}
					shopCheckins: entries(section: "shop") {
						... on shop_Entry {
							id
							firstName
							lat
							lng
						}
					}
					avatars: entries(section: "shop") {
						... on shop_Entry {
							id
							sellerImage {
								thumbnail: url(transform: "markerImage")
							}
						}
					}
				}
			`
		})
	})
		.then(data => {
			if (data.ok) return data.json();
			return {};
		})
		.catch(error => console.log(error));
